module.exports = {
  footerText: 'Cleversell © 2019',
}
